module.exports = __webpack_public_path__ + "static/hands_free-64bba3923241523ae6c91a19253ca367.svg";